import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe} from '@angular/common';
export class ServicesScheduleSetting {
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    let selectValue= sessionStorage.getItem("selectValue");
    console.log(selectValue,"排版类型");
    console.log("排版");
    if(webcontext.ConfigType.toLowerCase()=="form" &&(webcontext.OpType.toLowerCase()=="add" || webcontext.OpType.toLowerCase()=="edite")){
      let request = JSON.parse(webcontext.RequestBody);
      let datepie:DatePipe =new DatePipe("en-US");
         let nowdate = datepie.transform(new Date(),"yyyy-MM-dd");
        request["a_FK_SystemUser_ID"]= webcontext.Account.Id;//被排班人ID
        request["TBScheduleType"]="T008";//排班类型Code
        request["SchedulingMethod"] = 1;
        if(typeof(request.a_FK_Store_ID)=="undefined" || request.a_FK_Store_ID == null){//排班门店
          webcontext.ResponseMessage.ErrorMessage ="排班门店必选";
          webcontext.ResponseMessage.Success = false;
        }else
        if(typeof(request.a_FK_TBScheduleType_ID)=="undefined" || request.a_FK_TBScheduleType_ID == null){//排班类型
          webcontext.ResponseMessage.ErrorMessage ="排班类型必选";
          webcontext.ResponseMessage.Success = false;
        }else
        if(typeof(request.a_SNStartDate)=="undefined"){//排班开始日期
          webcontext.ResponseMessage.ErrorMessage ="开始时间不能为空";
          webcontext.ResponseMessage.Success = false;
        }else
        if(typeof(request.a_SNEndDate)=="undefined"){//排班结束日期
          webcontext.ResponseMessage.ErrorMessage ="结束时间不能为空";
          webcontext.ResponseMessage.Success = false;
        }
        else if(selectValue== "病假" || selectValue =="年假"  || selectValue =="调休"  || selectValue=="其他"){
           if(typeof(request.a_remark)=="undefined"){
            webcontext.ResponseMessage.Success = false;
            webcontext.ResponseMessage.ErrorMessage ="申请原因不能为空";
           
          }else{
            if(request.a_ID){//表示排版审批
              request.a_SNState=1;//表示未审核
            }else{
              request.a_SNState=1;//表示未审核
            } 
            if(request.a_SNStartDate.length > 6){
            
              request.a_SNStartDate = nowdate+" "+datepie.transform(request.a_SNStartDate.replace("T"," ").replace("-00:00","").replace(/-/g,"/"),"HH:mm:ss");
            }else{
              request.a_SNStartDate = nowdate+" "+request.a_SNStartDate+":00";
            }
            if(request.a_SNEndDate.length > 6){
              request.a_SNEndDate = nowdate+" "+datepie.transform(request.a_SNEndDate.replace("T"," ").replace("-00:00","").replace(/-/g,"/"),"HH:mm:ss");
            }else{
              request.a_SNEndDate = nowdate+" "+request.a_SNEndDate+":00";
            }
            if (!this.compareDate(request['a_SNStartDate'], request['a_SNEndDate'])) {
              webcontext.ResponseMessage.Success = false;
              webcontext.ResponseMessage.ErrorMessage = "结束时间不得小于或等于开始时间";
            } 
          }
        }
        else if(typeof(request.a_SNStartDate)!="undefined" && typeof(request.a_SNEndDate)!="undefined"){
          
          if(request.a_ID){//表示排版审批
            request.a_SNState=1;//表示未审核
          }else{
            request.a_SNState=1;//表示未审核
          } 
          // webcontext.SpecialParameter = request.a_SNStartDate + "&" + request.a_SNEndDate;
          // request.a_SNStartDate = nowdate+" "+datepie.transform(request.a_SNStartDate.replace("T"," ").replace("-00:00","").replace(/-/g,"/"),"HH:mm:ss");
          // request.a_SNEndDate = nowdate+" "+datepie.transform(request.a_SNEndDate.replace("T"," ").replace("-00:00","").replace(/-/g,"/"),"HH:mm:ss");
          if(request.a_SNStartDate.length > 6){
            
            request.a_SNStartDate = nowdate+" "+datepie.transform(request.a_SNStartDate.replace("T"," ").replace("-00:00","").replace(/-/g,"/"),"HH:mm:ss");
          }else{
            request.a_SNStartDate = nowdate+" "+request.a_SNStartDate+":00";
          }
          if(request.a_SNEndDate.length > 6){
            request.a_SNEndDate = nowdate+" "+datepie.transform(request.a_SNEndDate.replace("T"," ").replace("-00:00","").replace(/-/g,"/"),"HH:mm:ss");
          }else{
            request.a_SNEndDate = nowdate+" "+request.a_SNEndDate+":00";
          }
          // let seleckwork:boolean=true;
          // if(selectValue == "本休" || selectValue == "年假" || selectValue == "病假" || selectValue == "调休" || selectValue== "其他"){
          //   seleckwork=false;
          // }
          // if(seleckwork){
            if (!this.compareDate(request['a_SNStartDate'], request['a_SNEndDate'])) {
              webcontext.ResponseMessage.Success = false;
              webcontext.ResponseMessage.ErrorMessage = "结束时间不得小于或等于开始时间";
            } 
          // }
          
        
        }
        // console.log(request);
        // webcontext.ResponseMessage.ErrorMessage ="结束时间不能为空";
        // webcontext.ResponseMessage.Success = false;
      webcontext.RequestBody = JSON.stringify(request);

    }
    else if(webcontext.ConfigType.toLowerCase()=="view"){
          if(typeof(webcontext.RequestBody)=="undefined"){
            webcontext.RequestBody ={};
          }
          if(webcontext.ConfigName=="UserJurisdictionStoreRelation"){
            webcontext.RequestBody=JSON.stringify({"a_FK_SystemUser_ID":webcontext.Account.Id});
          }
    }
    return webcontext;
  }
  public HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext):WebResponesContext {
   const that = this;
   if(webParameterContext.ConfigType.toLowerCase()=="form"){
    if(webContext.ResponseMessage.Success){
      // localStorage.removeItem("loginsetting");
      if(window.location.href.indexOf("QYWXLogin")>-1){
        if(webContext.Status && webContext.Status.Info){
          let _QYWXLoginData = JSON.parse(sessionStorage.getItem("QYWXLoginData"));
          if(_QYWXLoginData && _QYWXLoginData.Status){
            _QYWXLoginData.Status["Info"] = webContext.Status.Info;
            sessionStorage.setItem("QYWXLoginData",JSON.stringify(_QYWXLoginData));
          }
        }
      }
         if(webContext.Other){
          webContext.Other.Success=true;
          webContext.url="/login";
         }else{
          webContext.Other={"Success":true,"url":"/login"};
         }
    }
   
    // webContext.ResponseMessage.ErrorMessage="排版成功,请尽快联系上级领导审批通过后方可进入此系统";
    // webContext.ResponseMessage.Success=false;
   }
    return webContext
  }
  
  private compareDate(begin, end) {
    const b1 = new Date(begin.replace(/-/g,"/")).getTime();
    const e1 = new Date(end.replace(/-/g,"/")).getTime();
    if (b1 >= e1) {
        return false;
    } else {
        return true;
    }
}
}